// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sliderWrapper":"_3pE5-","categoryList":"_3ibBn","categoryPlus":"_3t6w5","categoryMenu":"_2Sfe5"};